module.exports = __webpack_public_path__ + "static/img/logo.708b56f3.png";